import React, { useState, useEffect, useRef } from 'react';
import  { useNavigate, useLocation } from 'react-router-dom'
import Dropzone from 'react-dropzone';
import { api } from '../utils/endpoint.js'


import { connect } from 'react-redux';
import { 
  updateDocsType1, updateDocsType2, updateDocsType3, updateDocsType4, 
  updateDocsType5, updateDocsType6, updateDocsType7, updateDocsType8,
  updateDocsType9, updateDocsType10, updateDocsType11,
  updateDocsType12, updateDocsType13, updateDocsType14, updateDocsType15, updateDocsType16,updateDocsType17,updateDocsType18,updateDocsType19,updateDocsType20,updateDocsType21,
  deleteDocType1, deleteDocType2, deleteDocType3, deleteDocType4,
  deleteDocType5, deleteDocType6, deleteDocType7, deleteDocType8,
  deleteDocType9, deleteDocType10, deleteDocType11,
  deleteDocType12, deleteDocType13, deleteDocType14, deleteDocType15, deleteDocType16,deleteDocType17,deleteDocType18,deleteDocType19,deleteDocType20,deleteDocType21,
  deleteDocType1All, deleteDocType2All, deleteDocType3All, deleteDocType4All,
  deleteDocType5All, deleteDocType6All, deleteDocType7All, deleteDocType8All,
  deleteDocType9All, deleteDocType10All, deleteDocType11All,
  deleteDocType12All, deleteDocType13All, deleteDocType14All, deleteDocType15All, deleteDocType16All,deleteDocType17All,deleteDocType18All,deleteDocType19All,deleteDocType20All,deleteDocType21All,
  updateContactInfo, updateContactInfoTemporary, updateClaimType, deleteDocTypeAll, updateClaimId,
} from '../reducers/formActions'
import moment from 'moment'

import ThaivivatLogo from '../components/ThaivivatLogo.js'
import iconClose from '../images/newinform/ic_close.svg'
import iconChecked from '../images/newinform/ic_checked.svg'
import iconModalClose from '../images/modal/ic_close.svg'
import iconModalUpload from '../images/modal/ic_upload.svg'
import iconModalThumbFile from '../images/modal/ic_thumb_file.svg'
import iconModalTrash from '../images/modal/ic_trash.svg'
import imgQuestion from '../images/inform/question.svg'
import iconWarningAlert from '../images/alert/ic_warning.svg'


import iconSuccessAlert from '../images/alert/ic_alert_success.svg'

import iconCloseAlert from '../images/alert/ic_close.svg'

import Step1 from '../components/Step1'
import Step2 from '../components/Step2'
import Step3 from '../components/Step3'
import ProgressWaiting from '../components/progress-wating.js'
import ModalAlertError from '../components/ModalAlertError'

import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { compressImage } from '../utils/compress-image'
import { convertEngDateToThai } from '../utils/convert-date-to-thai'
import { CONTACT_TYPE } from '../utils/contact-type'
import { NEW_GARAGE } from '../services/fetchGarages';



function NewInformPage(props) {

  const navigate = useNavigate();
  const { state } = useLocation()

  const MySwal = withReactContent(Swal)

  const [step, setStep] = useState(1)
  const [lastStep, setLastStep] = useState(1)

  const [ isShowAlertError, setIsShowAlertError ] = useState(false)
  const [ alertTitle, setAlertTitle ] = useState('')
  const [ alertMessage, setAlertMessage ] = useState('')


  const showAlertError = (title, message) => {
    setAlertTitle(title)
    setAlertMessage(message)
    setIsShowAlertError(true)
  }

  const confirmClickError = () => {
    setIsShowAlertError(false)
    setIsShowLoading(false)
  }

  useEffect(() => {
    const onscroll = () => {
      const scrolledTo = window.scrollY + window.innerHeight;
      if ( (scrolledTo > document.body.scrollHeight - 200) && document.body.clientWidth <= 767  ){
          setIsShowHelpButton('140px')
      }else{
        setIsShowHelpButton('30px')
      }
    };
    window.addEventListener("scroll", onscroll);
    return () => {
      window.removeEventListener("scroll", onscroll);
    };
  }, []);



  const [ isShowUploadModal, setIsShowUploadModal ] = useState(false)
  const [ isShowHelpModal, setIsShowHelpModal ] = useState(false)
  const [ isShowHelpButton, setIsShowHelpButton ] = useState('30px')
  const [ imageUpload, setImageUpload ] = useState(null)
  const [ step1Info, setStep1Info ] = useState(null);
  const [ isShowLoading, setIsShowLoading ] = useState(false)

  const [ isStateDelete, setIsStateDelete ]= useState(false)
  const [ fileList, setFileList ]= useState([])
  const [ fileListThumb, setFileListThumb ]= useState([])
  const [ docType, setDocType ]= useState("")
  const [ enableStep, setEnableStep ] = useState({
    step1: true,
    step2: false,
    step3: false,
  })

  const [ customerName, setCustomerName ] = useState("")
  const [ customerEmail, setCustomerEmail ] = useState("")
  const [ customerTel, setCustomerTel ] = useState("")
  const [ customerMessage, setCustomerMessage ] = useState("")
  const [isValid, setIsValid] = useState(false)
  const [isShowAlertEmail, setIsShowAlertEmail] = useState(false)
  const [ alertText, setAlertText ] = useState('')

  useEffect(() => {
    if(
      customerName !== "" 
      && customerMessage !== ""
      && customerTel !== ""
      && customerTel.substring(0, 1) === '0' 
      && ( customerTel.length === 10 || customerTel.length === 9 )
    ){
      setIsValid(true)
    } else {
      setIsValid(false)
    }
  }, [ customerName, customerTel, customerMessage ])

  async function callApiSendEmail( ) {

    const dataBody = {
      "fullname": customerName,
      "email": customerEmail,
      "note": customerMessage,
      "tel": customerTel,
      "notify_number": props.notify_no,
      "ref_no": props.contact_info.ref_no,
      "car_license": props.lisence_info.front+""+props.lisence_info.no+" "+props.lisence_info.province,
      "contact_type": props.contact_info_temporary.contact_type,
      "contact_type_name":  props.contact_info_temporary.contactTypeName,
      "garage_name":  props.contact_info_temporary.garageName,
    }

    const requestOptions = {
      method: 'POST',  
      headers: {
        'Content-Type':'application/json'
      },
      body: JSON.stringify(dataBody)
    };

    fetch(api.email.contactUs(),requestOptions)
    .then( async (response) => {
      if(response.ok){
        return response.json();         
      }

      throw ({status:response.status, body: await response.json()});
    })
    .then(data => onSuccessCallApiSendEmail(data), (error) => {
      if (error) {
        onFailCallApiSendEmail(error )
      }
    }).catch((error) => {
      onFailCallApiSendEmail(error)
    });
  }

  function validateString( event ){
    if (!/[.A-Za-zก-ฮ-่-้-๊-๋-็ะ-ูเ-ไ-์ 0-9@_]/.test(event.nativeEvent.data) && (event.nativeEvent.data !== null) && (event.nativeEvent.data !== undefined) ) {
      return false
    }
    return true
  }


  function validateEmail( event ){
    if (!/[.A-Za-z0-9@_]/.test(event.nativeEvent.data) && (event.nativeEvent.data !== null) && (event.nativeEvent.data !== undefined) ) {
      return false
    }
    return true
  }

  function validateNumber( event ){
    if (!/[0-9]/.test(event.nativeEvent.data) && (event.nativeEvent.data !== null) && (event.nativeEvent.data !== undefined) ) {
      return false
    }
    return true
  }

  function onChangeText( event, setterInput ){
    if (!validateString(event)) {
      event.preventDefault();
    }
    else if( event.nativeEvent.data === undefined){
      //Clear
      setterInput("")
    }
    else{
      //Set Value
      setterInput(event.target.value)
    }
  }

  function onChangeEmail( event, setterInput ){
    if (!validateEmail(event)) {
      event.preventDefault();
    }
    else if( event.nativeEvent.data === undefined){
      //Clear
      setterInput("")
    }
    else{
      //Set Value
      setterInput(event.target.value)
    }
  }

  const regExTel = ( data ) => {
    if (!/(^[0]{0,1}$)|(^[0]{1}[0-9]{1,9}$)/.test(data) && 
        (data !== null) && 
        (data !== undefined) 
      ) {
      return false
    }
    return true
  }

  const isClear = ( event ) => {
    if ( event.nativeEvent.data === undefined) {
      return true;
    }
    return false;
  }

  const isValidateFull = (event, setter, method) => {
    if (isClear(event)) {
      setter("")
    } else {
      if(!method(event.target.value)){
        event.preventDefault();
      } else {
        //Set Value
        setter(event.target.value)
      }
    }
  }

  const validateTel = (event, setter) =>  {
    isValidateFull(event, setter, regExTel);
  }

  function onChangeNumber( event, setterInput ){

    validateTel(event, setterInput)
    // if (!validateNumber(event)) {
    //   event.preventDefault();
    // }
    // else if( event.nativeEvent.data === undefined){
    //   //Clear
    //   setterInput("")
    // }
    // else{
    //   //Set Value
    //   setterInput(event.target.value)
    // }
  }

  function submit(){
    callApiSendEmail()
  }

  function onSuccessCallApiSendEmail(data) {

    setCustomerEmail('')
    setCustomerName('')
    setCustomerTel('')
    setCustomerMessage('')

    navigate("/helpsuccess", { replace: true })
  }
  function onFailCallApiSendEmail(error) {
    setAlertText('เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง')
    setIsShowAlertEmail(true)
    setTimeout(()=>{
      setIsShowAlertEmail(false)
    }, 3000);
  }


  useEffect(() => {
    window.scrollTo(0, 0)
    if(props.notify_no === ""){
      navigate("/inform", { replace: true })
    } 
  }, [ step ])


  function gotoHome(){
    navigate("/", { replace: true })
  }

  useEffect(() => {

    if (isStateDelete === false) {
      initFileList(docType)
    }
  }, [ props.claim_info.docs ])

  function initFileList(docType){
    let items = getFilesList(docType)
    setFileList(items);
  }


  function onUploadFile( files, docType ){
    for(let i = 0; i < files.length; i++){
      uploadToServer(files[i], docType)
    }
  }

  async function uploadToServer( file, docType){
    callApiUpload( file, docType )
  }

  async function callApiGetFileDraft(  claimId ) {
    fetch(api.objectStorage.docs(`claim_id=${claimId}`))
    .then(response => response.json())
    .then(data => onSuccessCallApiGetFile(data), (error) => {
      if (error) {
        onFailCallApiGetFile(error )
      }
    })
  }
  function onSuccessCallApiGetFile( data ){
    setIsShowLoading(false)
    if(data) {
      for(let i = 0; i < data.length; i++){
        let image = data[i]
        updateFileList(image, parseInt(image.docType))

      }
    }
  }
  function onFailCallApiGetFile( error ){
    setIsShowLoading(false)
  }
  
  

  async function callApiUpload( file, docType ) {
    setIsShowLoading(true)
    const formData = new FormData();
    formData.append("file", file)
    let fileCompress = await compressImage(file)
    if(fileCompress !== null){
      formData.append("thumb", fileCompress)
    }
    const requestOptions = {
      method: 'POST',
      body: formData
    };
    fetch(api.objectStorage.uploads(`doc_type=${docType}&claim_id=${props.claim_id}`), requestOptions)
    .then(response => response.json())
    .then(data => onSuccessCallApiUpload(data), (error) => {
    
      if (error) {
        onFailCallApiUpload( error )
      }
    });
  }

  function callApiDelete( doc_type , doc_id) {
    let body = JSON.stringify({})
    if(doc_id != null) {
      body = JSON.stringify({
        "claim_id": props.claim_id,
        "doc_id": doc_id,
      })
    } else if(doc_type != null){
      body = JSON.stringify({
        "claim_id": props.claim_id,
        "doc_type": doc_type,
      })
    } 
    const requestOptions = {
      method: 'DELETE',
      headers: {
        'Content-Type':'application/json'
      },
      body: body
    };
    fetch(api.objectStorage.deleteDoc(),requestOptions)
    .then(response => response.json())
    .then(data => onSuccessCallApiDelete(data), (error) => {
      if (error) {
        onFailCallApiDelete( error )
      }
    });
  }


  function onSuccessCallApiDelete( data ){
  }
  function onFailCallApiDelete( error ){

  }


  function onSuccessCallApiUpload( data ){
    if(data.id){
      setIsShowLoading(false)
      updateFileList(data, docType)
      setIsShowUploadModal(false)
    }else{
      setIsShowLoading(false)
      showAlertError('เกิดข้อผิดพลาด กรุณาติดต่อฝ่ายลูกค้าสัมพันธ์ โทร. 1231 กด 4')
    }
  }
  function onFailCallApiUpload( error ){
    setIsShowLoading(false)
  }

  async function updateFileList(data, docType){
    // let filePrevState = getFilesList(docType)
    let filePrevState = fileList

    let objFile = {
      id:  data.id,
      name : data.fileName,
      path : data.fileThumb,
      size: data.fileSize,
      date: data.updateAt,
      type: data.fileType
    }
    addFileToStore(objFile, docType)
    filePrevState.push(objFile)
    setFileList(filePrevState)
  }

  function addFileToStore(objFile, docType){
    switch(docType){
      case 1: props.updateDocsType1(objFile); break;
      case 2: props.updateDocsType2(objFile); break;
      case 3: props.updateDocsType3(objFile); break;
      case 4: props.updateDocsType4(objFile); break;
      case 5: props.updateDocsType5(objFile); break;
      case 6: props.updateDocsType6(objFile); break;
      case 7: props.updateDocsType7(objFile); break;
      case 8: props.updateDocsType8(objFile); break;
      case 9: props.updateDocsType9(objFile); break;
      case 10: props.updateDocsType10(objFile); break;
      case 11: props.updateDocsType11(objFile); break;
      case 12: props.updateDocsType12(objFile); break;
      case 13: props.updateDocsType13(objFile); break;
      case 14: props.updateDocsType14(objFile); break;
      case 15: props.updateDocsType15(objFile); break;
      case 16: props.updateDocsType16(objFile); break;
      case 17: props.updateDocsType17(objFile); break;
      case 18: props.updateDocsType18(objFile); break;
      case 19: props.updateDocsType19(objFile); break;
      case 20: props.updateDocsType20(objFile); break;
      case 21: props.updateDocsType21(objFile); break;
      default: break;
    }
  }

  function deleteFileToStore(docType, index){
    switch(docType){
      case 1: props.deleteDocType1(index); break;
      case 2: props.deleteDocType2(index); break;
      case 3: props.deleteDocType3(index); break;
      case 4: props.deleteDocType4(index); break;
      case 5: props.deleteDocType5(index); break;
      case 6: props.deleteDocType6(index); break;
      case 7: props.deleteDocType7(index); break;
      case 8: props.deleteDocType8(index); break;
      case 9: props.deleteDocType9(index); break;
      case 10: props.deleteDocType10(index); break;
      case 11: props.deleteDocType11(index); break;
      case 12: props.deleteDocType12(index); break;
      case 13: props.deleteDocType13(index); break;
      case 14: props.deleteDocType14(index); break;
      case 15: props.deleteDocType15(index); break;
      case 16: props.deleteDocType16(index); break;
      case 17: props.deleteDocType17(index); break;
      case 18: props.deleteDocType18(index); break;
      case 19: props.deleteDocType19(index); break;
      case 20: props.deleteDocType20(index); break;
      case 21: props.deleteDocType21(index); break;
      default: break;
    }
  }
  function deleteAllFileToStore(docType){
    switch(docType){
      case 1: props.deleteAllDocType1(); break;
      case 2: props.deleteAllDocType2(); break;
      case 3: props.deleteAllDocType3(); break;
      case 4: props.deleteAllDocType4(); break;
      case 5: props.deleteAllDocType5(); break;
      case 6: props.deleteAllDocType6(); break;
      case 7: props.deleteAllDocType7(); break;
      case 8: props.deleteAllDocType8(); break;
      case 9: props.deleteAllDocType9(); break;
      case 10: props.deleteAllDocType10(); break;
      case 11: props.deleteAllDocType11(); break;
      case 12: props.deleteAllDocType12(); break;
      case 13: props.deleteAllDocType13(); break;
      case 14: props.deleteAllDocType14(); break;
      case 15: props.deleteAllDocType15(); break;
      case 16: props.deleteAllDocType16(); break;
      case 17: props.deleteAllDocType17(); break;
      case 18: props.deleteAllDocType18(); break;
      case 19: props.deleteAllDocType19(); break;
      case 20: props.deleteAllDocType20(); break;
      case 21: props.deleteAllDocType21(); break;
      default: break;
    }
  }
  


  function getFilesList( docType ){
    switch(docType){
      case 1: return props.claim_info.docs.code_1.items;
      case 2: return props.claim_info.docs.code_2.items;
      case 3: return props.claim_info.docs.code_3.items;
      case 4: return props.claim_info.docs.code_4.items;
      case 5: return props.claim_info.docs.code_5.items;
      case 6: return props.claim_info.docs.code_6.items;
      case 7: return props.claim_info.docs.code_7.items;
      case 8: return props.claim_info.docs.code_8.items;
      case 9: return props.claim_info.docs.code_9.items;
      case 10: return props.claim_info.docs.code_10.items;
      case 11: return props.claim_info.docs.code_11.items;
      case 12: return props.claim_info.docs.code_12.items;
      case 13: return props.claim_info.docs.code_13.items;
      case 14: return props.claim_info.docs.code_14.items;
      case 15: return props.claim_info.docs.code_15.items;
      case 16: return props.claim_info.docs.code_16.items;
      case 17: return props.claim_info.docs.code_17.items;
      case 18: return props.claim_info.docs.code_18.items;
      case 19: return props.claim_info.docs.code_19.items;
      case 20: return props.claim_info.docs.code_20.items;
      case 21: return props.claim_info.docs.code_21.items;
      default:  return [];
    }
  }

  function onSearchRefNo(refNo) {

    if (isShowLoading == false ) {
      setIsShowLoading(true)
      props.deleteDocTypeAll()
      props.updateContactInfo(
        {
          contact_title_code : '',
          name : '',
          contact_type : 0,
          garage_code : '',
          garage_name : '',
          no_garage_in_system : false,
          is_attorney : false,
          is_company : false,
          tel : '',
          email : '',
          line_id : '',
          ref_no: '',
          labor_cost: 0.00,
          auto_parts: 0.00,
          loss_of_benefit: 0.00,
          tow_car: 0.00,
        }
      )
      callApiGetTracking(refNo)
    }
  }

  async function callApiGetTracking( ref_no ) {


    const params = `ref_no=${ref_no}&notify_number=${props.notify_no}&car_license_alp=${props.lisence_info.front}&car_license_no=${props.lisence_info.no}&car_license_province=${props.lisence_info.province}&register_plate=${props.lisence_info.is_red_plate}&sufferer_type=${props.lisence_info.sufferer_type}`
    fetch(api.nonemcs.draft(params))
    .then( (response) => {
      if(response.ok){
        return response.json();         
      }

      throw ({status:response.status});
    })
    .then(data => onSuccessCallApiGet(data), (error) => {
      if (error) {
        if(error?.status == 500){
          showAlertError('เกิดข้อผิดพลาด กรุณาติดต่อฝ่ายลูกค้าสัมพันธ์ โทร. 1231 กด 4')
          return
        }
        onFailCallApiGet(error )
        
      }
    }).catch((error) => {
      showAlertError('เกิดข้อผิดพลาด กรุณาติดต่อฝ่ายลูกค้าสัมพันธ์ โทร. 1231 กด 4')
      return
    });
  }
  async function onSuccessCallApiGet( data ){
    setIsShowLoading(false)
    if (data && data.notifyNumber) {
      
      if (data.isConfirmForm == false) {
        props.updateClaimId( data.id )
        props.updateContactInfo(
          {
            contact_title_code : data.contactTitleCode,
            name : data.contactName,
            contact_type : data.contactType,
            garage_code : data.garageCode,
            garage_name : data.garageName,
            no_garage_in_system : data.noGarageInSystem,
            is_attorney : (data.assignee === 'N')? false : true,
            is_company : (data.legalEntity === 'N')? false : true,
            tel : data.phoneNumber,
            email : data.email,
            line_id : data.lineId,
            ref_no: data.referenceNo,
            labor_cost: Number(data.laborCost),
            auto_parts: Number(data.autoParts),
            loss_of_benefit: Number(data.lossOfBenefit),
            tow_car: Number(data.towCar),
          }
        )
        props.updateContactInfoTemporary({
          ...props.contact_info_temporary,
          garageName: data.garageName,
          contactTypeName: CONTACT_TYPE(data.contactType+''),
          contact_type: data.contactType
        })
        props.updateClaimType({
          type : data.claimType && data.claimType != 'null' ? parseInt(data.claimType+'') : data.suffererType != 0 ? 6 : 1
        }) 


        await callApiGetFileDraft(data.id);
      } 
      
      else {
        showAlertError('ทางสินไหมได้รับข้อมูลเลขที่รายการนี้ เรียบร้อยแล้ว', 'หากมีข้อสงสัยกรุณาติดต่อที่เบอร์ 1231 กด 4')
      }
    } else   if (data && data.code  && data.code == 400 ) {
      showAlertError(data.message, '')
      let newItem = enableStep;
      newItem.step1 = true
      newItem.step2 = false
      newItem.step3 = false
      setEnableStep(newItem)
      setStep1Info(step1Info)
      setStep(1)
    }


  }
  async function onFailCallApiGet( error ){
    showAlertError('ไม่พบเลขที่รายการนี้ กรุณาทำรายการใหม่', '')
    setIsShowLoading(false)
  }


  function onSuccessStep1( 
    customerName, contactType, garageCode, garageName,noGarageInSystem,
    isAttorney, isCompany, 
    customerTel, customerEmail, customerLine, refNo, contactTitleCode

   ){
    if (isShowLoading == false){
      callApiUpdateContactInfo(
        customerName, contactType, garageCode, garageName,noGarageInSystem,
        isAttorney, isCompany, 
        customerTel, customerEmail, customerLine, refNo, contactTitleCode
      )
    }

  }

  function onSuccessStep2(claimType, laborCost, autoParts, lossOfBenefit, towCar){
    if (isShowLoading == false) {
      callApiUpdateContactClaimInfo(claimType, laborCost, autoParts, lossOfBenefit, towCar)
    }
  }
  
  function onSelectedFile( tags ){
    setDocType( tags )
    setIsShowUploadModal(true)
    initFileList(tags)
  }
  function onCloseModalUploadFile(){
    closeAlert()
    setIsShowUploadModal(false)
  }


  function getTitle(docType){
    switch(docType) {
      case 1: return props.claim_info.docs.code_1.name
      case 2: return props.claim_info.docs.code_2.name
      case 3: return props.claim_info.docs.code_3.name
      case 4: return props.claim_info.docs.code_4.name
      case 5: return props.claim_info.docs.code_5.name
      case 6: return props.claim_info.docs.code_6.name
      case 7: return props.claim_info.docs.code_7.name
      case 8: return props.claim_info.docs.code_8.name
      case 9: return props.claim_info.docs.code_9.name
      case 10: return props.claim_info.docs.code_10.name
      case 11: return props.claim_info.docs.code_11.name
      case 12: return props.claim_info.docs.code_12.name
      case 13: return props.claim_info.docs.code_13.name
      case 14: return props.claim_info.docs.code_14.name
      case 15: return props.claim_info.docs.code_15.name
      case 16: return props.claim_info.docs.code_16.name
      case 17: return props.claim_info.docs.code_17.name
      case 18: return props.claim_info.docs.code_18.name
      case 19: return props.claim_info.docs.code_19.name
      case 20: return props.claim_info.docs.code_20.name
      case 21: return props.claim_info.docs.code_21.name
      default:
        return ""
    }
  }
  function getDescription(docType){
    switch(docType) {
      case 1: return props.claim_info.docs.code_1.description
      case 2: return props.claim_info.docs.code_2.description
      case 3: return props.claim_info.docs.code_3.description
      case 4: return props.claim_info.docs.code_4.description
      case 5: return props.claim_info.docs.code_5.description
      case 6: return props.claim_info.docs.code_6.description
      case 7: return props.claim_info.docs.code_7.description
      case 8: return props.claim_info.docs.code_8.description
      case 9: return props.claim_info.docs.code_9.description
      case 10: return props.claim_info.docs.code_10.description
      case 11: return props.claim_info.docs.code_11.description
      case 12: return props.claim_info.docs.code_12.description
      case 13: return props.claim_info.docs.code_13.description
      case 14: return props.claim_info.docs.code_14.description
      case 15: return props.claim_info.docs.code_15.description
      case 16: return props.claim_info.docs.code_16.description
      case 17: return props.claim_info.docs.code_17.description
      case 18: return props.claim_info.docs.code_18.description
      case 19: return props.claim_info.docs.code_19.description
      case 20: return props.claim_info.docs.code_20.description
      case 21: return props.claim_info.docs.code_21.description
      default:
        return ""
    }
  }


  function onConfirm(referenceNo, linkDoc){
    navigate("/summary", { state: { "referenceNo": referenceNo, "linkDoc": linkDoc, "customerTel":customerTel }, replace: true })
  }

  function onEditStep1(){
    setLastStep(1)
    let newItem = enableStep;
    newItem.step1 = true
    newItem.step2 = false
    newItem.step3 = false
    setEnableStep(newItem)
    setStep(1)
  }


  function onEditStep2(){
    setLastStep(2)
    let newItem = enableStep;
    newItem.step1 = true
    newItem.step2 = true
    newItem.step3 = false
    setEnableStep(newItem)
    setStep(2)
  }


  function showCancelUpload(  ){

    Swal.fire({
      title: '<div data-testid="popup-title-text" >คุณไม่ต้องการยื่นเอกสาร</div>',
      html: `<div data-testid="popup-description-text" class="swal-content-message">คุณต้องการยกเลิกการส่งเอกสารเรียกร้องค่าสินไหมทดแทน เลขรับแจ้ง ${props.notify_no}</div>`,
      showCancelButton: true,
      confirmButtonColor: '#009640',
      confirmButtonText: '<span data-testid="confirm-button" class="">ใช่</span>',
      cancelButtonText: '<span data-testid="cancel-button" class="">ไม่ใช่</span>',
      cancelButtonColor: '#FFFFF',
      customClass: {
        popup:  'swal-content swal-contrainner',
        content : 'swal-content',
        icon: 'swal-warning-icon-content',
        title: 'swal-warning-title',
        confirmButton: 'swal-warning-confirm',
        cancelButton: 'swal-warning-cancel',
        actions: 'swal-warning-action'
      }

    }).then((result) => {
      if (result.isConfirmed) {
        gotoHome()
      }
    })
  }

  function onHandlerClickMenu( step ){
    if(step === 1){
      if( enableStep.step1 ){
        setStep(1)
      }
    }
    else if(step === 2){
      if( enableStep.step2 ){
        setStep(2)
      }
    }
    else if(step === 3){
      if( enableStep.step3 ){
        setStep(3)
      }
    }
  }

  const [ isShowAlert, setIsShowAlert ] = useState(false)
  const [ indexUndoDelete, setIndexUndoDelete ] = useState(-1)
  const [ idUndoDelete, setIdUndoDelete ] = useState(-1)
  const [ docTypeUndoDelete, setDocTypeUndoDelete ] = useState(-1)
  const [ isClearAllDocType, setIsClearAllDocType ] = useState(false)
  const [ filenameUndoDelete, setFileNameUndoDelete ] = useState([])
  const timer = useRef(null);
  const [ counter, setCounter ] = useState(1);
  function showAlert(){
    clearIntervalAlert()
    setIsShowAlert(true)
    setCounter(1)
    setAlertTimer()
  }
  function closeAlert(){
    setIsStateDelete(false)
    // confirm Remove
    confirmRemove()
    clearIntervalAlert()
  }
  function setAlertTimer(){
    timer.current = setInterval(() => {
      setCounter((v) => v + 1)
    }, 1000);
    return () => clearTimeout(timer.current);
  }
  useEffect(() => {
    if (counter >= 3){
      // confirm Remove
      setIsStateDelete(false)
      confirmRemove()
      clearIntervalAlert()
    }
  }, [counter]);

  function clearIntervalAlert(){
    clearInterval(timer.current);
    setIsShowAlert(false);
    setCounter(1)
  }

  function undoDelete(){
    setIsStateDelete(false)
    clearIntervalAlert()
    let filePrevState = [...fileListThumb]
    setFileList(filePrevState)
    setFileListThumb([])

    clearStateUndo()
  }

  function clearAll(docType){
    let filePrevStateUndo = [...fileList]
    if(filePrevStateUndo.length === 0){
      return;
    }
    setFileListThumb(filePrevStateUndo)

    setFileList([])

    setIsClearAllDocType(true)
    setDocTypeUndoDelete(docType)
    setIndexUndoDelete(0)
    setIdUndoDelete(0)
    setFileNameUndoDelete(filePrevStateUndo)
    // show alert
    showAlert();
  }

  function deleteImage(docType, index ){
    if(fileList.length === 0){
      return;
    }
    setIsStateDelete(true)
    if ( docTypeUndoDelete !== -1 &&  indexUndoDelete !== -1) {
      confirmRemove()
    }
    let filePrevStateUndo = [...fileList]
    setFileListThumb(filePrevStateUndo)

    let filePrevState = [...fileList]
    filePrevState.splice(index, 1)
    setFileList(filePrevState)


    setDocTypeUndoDelete(docType)
    setIsClearAllDocType(false)
    setIndexUndoDelete(index)
    let itemDel = filePrevStateUndo[index]
    setIdUndoDelete(itemDel.id)
    setFileNameUndoDelete([itemDel])
    // show alert
    showAlert();
  }

  function clearStateUndo(){
    setDocTypeUndoDelete(-1)
    setIsClearAllDocType(false)
    setIndexUndoDelete(-1)
    setIdUndoDelete(-1)
    setFileNameUndoDelete([])
  }

  async function confirmRemove(){
    if ( docTypeUndoDelete !== -1 &&  indexUndoDelete !== -1) {
      if (isClearAllDocType) {
        callApiDelete(docTypeUndoDelete, null)
        deleteAllFileToStore( docTypeUndoDelete)
      } else {
        if( filenameUndoDelete.length > 1 ){
          callApiDelete(docTypeUndoDelete, null)
          deleteAllFileToStore( docTypeUndoDelete)
        }
        else if(filenameUndoDelete.length > 0){
          callApiDelete( null,  idUndoDelete )
          deleteFileToStore( docTypeUndoDelete, indexUndoDelete)
        }
      }
    }
    clearStateUndo()
  }


  function callApiUpdateContactInfo(
    customerName, contactType, garageCode, garageName, noGarageInSystem,
    isAttorney, isCompany, 
    customerTel, customerEmail, customerLine, refNo, contactTitleCode) {
      setIsShowLoading(true)
    const reqBody = JSON.stringify(
      {
        "ref_no": refNo,
        "notify_number": props.notify_no,
        "car_license": props.lisence_info.front+""+props.lisence_info.no+""+props.lisence_info.province,
        "car_license_alp": props.lisence_info.front,
        "car_license_no": props.lisence_info.no,
        "car_license_province": props.lisence_info.province,
        "register_plate": props.lisence_info.is_red_plate,
        "driver_name": props.lisence_info.driver_name,
        "sufferer_type": props.lisence_info.sufferer_type,
        "contact_title_code": contactTitleCode,
        "contact_name": customerName,
        "contact_type": contactType,
        "garage_code": ( garageCode === NEW_GARAGE ? null:garageCode ),
        "garage_name": garageName,
        "no_garage_in_system": noGarageInSystem,
        "assignee": (isAttorney)? 'Y' : 'N',
        "legal_entity": (isCompany)? 'Y' : 'N',
        "phone_number": customerTel,
        "email": customerEmail,
        "line_id": customerLine,
        "claim_type": null
    }
    )
    const requestOptions = {
      method: 'POST',  
      headers: {
        'Content-Type':'application/json'
      },
      body: reqBody
    };
    fetch(api.nonemcs.newTask(), requestOptions)
    .then(response => response.json())
    .then(data => onSuccessCallApiUpdateContactInfo(data), (error) => {
      if (error) {
      }
    });
  }

  function onSuccessCallApiUpdateContactInfo( response  ){
    setIsShowLoading(false)
    if(response !== null && response !== undefined){   
      
      props.updateContactInfo(
        {
          contact_title_code : response.contactTitleCode,
          name : response.contactName,
          contact_type :  parseInt(response.contactType+''),
          garage_code :  response.garageCode,
          garage_name :  response.garageName,
          no_garage_in_system :  response.noGarageInSystem,
          is_attorney :  response.assignee === 'Y' ? true : false,
          is_company :  response.legalEntity === 'Y' ? true : false,
          tel :  response.phoneNumber,
          email :  response.email,
          line_id :  response.lineId,
          ref_no:  response.referenceNo,
          labor_cost: Number(response.laborCost),
          auto_parts: Number(response.autoParts),
          loss_of_benefit: Number(response.lossOfBenefit),
          tow_car: Number(response.towCar),
        }
      )

      props.updateClaimId(response.id) 
      props.updateClaimType({
        type : response.claimType ? parseInt(response.claimType+'') : null
      })

      setLastStep(2)
      let newItem = enableStep;
      newItem.step1 = true
      newItem.step2 = true
      newItem.step3 = false
      setEnableStep(newItem)
      setStep1Info(step1Info)
      setStep(2)
    }
    else{
      onFailCallApiUpdateContactInfo()
    }
  }
  function onFailCallApiUpdateContactInfo( error  ){
    setIsShowLoading(false)
    let newItem = enableStep;
    newItem.step1 = true
    newItem.step2 = false
    newItem.step3 = false
    setEnableStep(newItem)
    setStep1Info(step1Info)
    setStep(1)
    if(error !== null && error !== undefined){
    }
  }

  async function callApiUpdateContactClaimInfo(documentType, laborCost, autoParts, lossOfBenefit, towCar) {
    setIsShowLoading(true)
    props.updateClaimType({
      type : documentType
    })
    const bodyRaw = JSON.stringify(
      {
        "claim_id": props.claim_id,
        "claim_type": documentType,
        "labor_cost": laborCost,
        "auto_parts": autoParts,
        "loss_of_benefit": lossOfBenefit,
        "tow_car": towCar,
      }
    )
    const requestOptions = {
      method: 'PUT',  
      headers: {
        'Content-Type':'application/json'
      },
      body: bodyRaw
    };
    fetch(api.nonemcs.update(), requestOptions)
    .then( (response) => {
      if(response.ok){
        return response.json();         
      }

      throw ({status:response.status});
    })
    .then(data => onSuccessCallApiUpdateClaimInfo(data), (error) => {
      if (error) {
        if(error?.status == 500){
          showAlertError('เกิดข้อผิดพลาด กรุณาลองใหม่ หากมีข้อสงสัยกรุณาติดต่อที่เบอร์ 1231 กด 4')
          return
        }
      }
    }).catch((error) => {
      showAlertError('เกิดข้อผิดพลาด กรุณาลองใหม่ หากมีข้อสงสัยกรุณาติดต่อที่เบอร์ 1231 กด 4')
      return
    });

  }

  function onSuccessCallApiUpdateClaimInfo( response  ){
    setIsShowLoading(false)
    if(response.statusCode == 404){
      showAlertError(response.message, '')
      return
    }

    props.updateClaimType({
      type : response.claimType
    }) 

    props.updateContactInfo(
      {
        contact_title_code : response.contactTitleCode,
        name : response.contactName,
        contact_type :  parseInt(response.contactType+''),
        garage_code :  response.garageCode,
        garage_name :  response.garageName,
        no_garage_in_system :  response.noGarageInSystem,
        is_attorney :  response.assignee === 'Y' ? true : false,
        is_company :  response.legalEntity === 'Y' ? true : false,
        tel :  response.phoneNumber,
        email :  response.email,
        line_id :  response.lineId,
        ref_no:  response.referenceNo,
        labor_cost: Number(response.laborCost),
        auto_parts: Number(response.autoParts),
        loss_of_benefit: Number(response.lossOfBenefit),
        tow_car: Number(response.towCar),
      }
    )

    setLastStep(3)
    let newItem = enableStep;
    newItem.step1 = false
    newItem.step2 = false
    newItem.step3 = true
    setEnableStep(newItem)
    setStep(3)

  }


  return (
  <div className="w-full flex bg-white font-prompt overflow-y-hidden ">

    <div className={' w-full bg-black  bg-opacity-30 h-screen z-40 justify-center flex align-middle '+((isShowUploadModal)? ' fixed ' : ' hidden ')}>

      <div className=' flex-wrap w-full lg:w-[640px] h-full lg:h-[576px]  bg-opacity-100 bg-white rounded-none md:rounded-lg z-50 mt-0 lg:mt-[20px]'>
        <div className=' relative w-full'>

          <div class="flex lg:flex-none h-screen lg:h-fit  flex-col lg:flex-row w-full flex-nowrap lg:flex-wrap">

          
            <div className='flex lg:flex-none w-full h-[64px] py-5 px-6 border-b border-grey-500'>
              <div className='grow w-full'>
                <span data-testid='popup-title-label' className='text-lg leading-6 font-medium'>รายการอัพโหลด</span>
              </div>
              <div className='flex-none '>
                <img data-testid='popup-close-button' onClick={ (e)=> { onCloseModalUploadFile() }} src={iconModalClose} alt="ic-close-modal" className=' cursor-pointer w-[24px] h-[24px]' /> 
              </div>
            </div>

            <div className='flex lg:flex-none  flex-wrap w-full '>
              <div data-testid='popup-claimDoc-text' className='flex flex-wrap w-full px-6 pt-6'>
                <span className='w-full text-base leading-5 font-medium'>{ getTitle(docType)  }</span>
                <span className='w-full mt-1 text-sm font-normal leading-5 text-grey-600'>{   getDescription(docType)   }</span>
              </div>
              <div className='flex flex-wrap w-full px-6 mt-4'>
                    <Dropzone 
                          maxSize={(10*1024*1024)}
                          accept={'image/jpeg, image/png, image/heic, image/heif, application/pdf'}
                          onDropRejected={(e) => {
                            const rej = []
                            for (let i = 0; i < e.length; i++) {
                              if (
                                e[i].file.path.toString().toLowerCase().indexOf('.heic') >= 0 ||
                                e[i].file.path.toString().toLowerCase().indexOf('.heif') >= 0
                              ) {
                                rej.push(e[i].file)
                              }
                            }
                              onUploadFile(rej, docType) 
                            
                          }}
                          onDropAccepted={acceptedFiles => { 
                            onUploadFile(acceptedFiles, docType) 
                          }}>
                        {({getRootProps, getInputProps}) => (
                          <section data-testid='popup-upload-button' {...getRootProps({className: 'dropzone'})} className={' flex w-full  mt-2 border rounded-lg justify-center  border-dashed items-center border-grey-300 ' }>
                            <div >
                              <input className='dropzone' {...getInputProps()} />
                              <div className='justify-center mt-[42px]'>
                                <img src={iconModalUpload} className='mx-auto w-[24px] h-[24px]' alt="" />
                              </div>
                              <div className=' flex flex-wrap mt-3 justify-center text-center'>
                                <label className='text-sm font-normal '>ลากวางรูปที่คุณจะอัพโหลด</label>
                                <label className='ml-1 text-sm text-grey-800'>หรือ <label className='text-sm text-green-500'>เลือกจากเครื่อง</label></label>
                              </div>
                              <div className='w-full flex flex-wrap justify-center text-center mt-[4px]  mb-[42px]'>
                              
                                <div className='w-full flex'>
                                  <label className='w-full text-xs font-normal text-grey-600'>PNG, JPG, PDF (สูงสุดไม่เกิน 10mb.)</label>
                                </div>
                              
                              </div>
                              
                            </div>
                          </section>
                        )}
                  </Dropzone>
              </div>
            </div>

            <div className=' flex-1 lg:flex-none w-full lg:h-[175px] px-6 mt-4  flex-wrap  overflow-auto'>
            
              {
                fileList.map(function(item, index){
                  return (
                    <div className=' flex w-full  py-3 border-b border-grey-300'>
                      <div className='grow w-full flex'>
                        <div className='flex'>
                          <img className='w-[40px] h-[40px] rounded' src={( (item.type === "application/pdf")? iconModalThumbFile : item.path  )} alt="icon-thumb-file" />
                        </div>
                        <div className='flex flex-wrap ml-3 my-auto'>
                          <span data-testid='uploaded-photoName-text' className='w-full text-sm font-normal'>{ item.name }</span>
                          <span className='w-full mt-[4px] text-xs font-normal text-grey-800'>{ convertEngDateToThai(moment(item.date).format('DD/MM/YYYY')) } · {Math.round(item.size/1000)} kb</span>
                        </div>
                      </div>
                      <div className='flex-none flex'>
                        {/* <div className='w-[56px] my-auto'>
                          <div class="w-full bg-gray-300 rounded-full h-[8px] ">
                            <div class="bg-green-500 h-[8px] rounded-full w-5/12" ></div>
                          </div>
                        </div>
                        <div className='ml-4  my-auto'>
                          <span className='text-xs'>5 %</span>
                        </div>
                        <div className='ml-4  my-auto'>
                          <img src={iconModalRemoveFile} alt="icon-thumb-file" className='w-[16px] h-[16px]'  />
                        </div> */}
                        <div className='ml-4  my-auto'>
                          <button data-testid='delete-button' onClick={(e)=>{ deleteImage(docType, index) }}>
                            <img src={iconModalTrash} alt="icon-thumb-file" className='w-[16px] h-[16px]'  />
                          </button>
                        </div>
                        
                      </div>
                    </div>
                  )
                })
              }
              
            </div>
          
            
          
          

            <div className='flex lg:flex-none flex-wrap w-full h-[72px] px-6 py-4  border-t border-grey-300 '>
              <div className='flex flex-wrap w-full lg:w-1/2 pr-2 justify-start'>

                <button
                    data-testid='popup-clear-button' 
                    onClick={ () => { clearAll(docType) }}
                    className={' w-full lg:w-fit px-4 py-2 border border-grey-300  text-base font-medium rounded-md border-radius-other bg-white text-black '}>
                      ล้างข้อมูล
                </button>
              </div>
              <div className='flex flex-wrap w-1/2 pl-2 justify-end  '>

                {/* <button 
                    className={' px-4 py-2 border border-grey-300  text-base font-medium rounded-md border-radius-other bg-green-500 text-white '}>
                      บันทึก
                </button> */}
              </div>
            </div>

          </div>

          <div className={((isShowAlert)? ' absolute ' : ' hidden ' )+ ' flex bottom-0 inset-x-0 mx-auto shadow-alert border border-white  w-[360px] h-[40px] py-[10px] px-[12px] mb-[96px] bg-white rounded-lg '}>

            <div className='flex w-full'>
              <div className='grow w-full flex-wrap flex'>
                <img src={iconSuccessAlert} alt="icon-warning-alert" className='w-[16px] h-[16px] mr-[8px] my-auto' />
                <span data-testid='toast-description-text' className='text-sm not-italic font-normal  my-auto w-[240px] truncate' >ลบ { (filenameUndoDelete.length > 0)? (filenameUndoDelete.length > 1)? (filenameUndoDelete.length)+" รายการ" : "เอกสาร "+filenameUndoDelete[0].name : ''}</span>
              </div>
              <div className='flex-none flex-wrap flex'>
                  <span onClick={(e) => { undoDelete() }} className=' cursor-pointer text-sm not-italic font-medium text-green-500  my-auto' >เลิกทำ</span>
                  <button onClick={(e) => { closeAlert() }}><img src={iconCloseAlert} alt="icon-close-alert " className='w-[16px] h-[16px] ml-[8px] my-auto' /></button>
              </div>
            </div>

            {/* <div className={((true)? ' absolute ' : ' hidden ' )+ ' flex bottom-0 inset-x-0 mx-auto shadow-alert border border-white  w-[360px] h-[40px] py-[10px] px-[12px] mb-[96px] bg-white rounded-lg '}>

              <div className='flex w-full'>
            
                <div className='w-full flex-wrap flex'>
                    <span onClick={(e) => { undoDelete() }} className=' cursor-pointer text-sm not-italic font-medium text-green-500  my-auto' >แจ้งเตือน</span>
                    <button onClick={(e) => { closeAlert() }}><img src={iconCloseAlert} alt="icon-close-alert " className='w-[16px] h-[16px] ml-[8px] my-auto' /></button>
                </div>
              </div>

            </div> */}

          </div>

        </div>


      
      </div>

    </div>

    <div className={' w-full bg-black  bg-opacity-30 h-screen z-40 justify-center flex align-middle '+((isShowHelpModal)? ' fixed ' : ' hidden ')}>
      <div className=' flex-wrap w-full lg:w-[480px] h-full lg:h-[676px]  bg-opacity-100 bg-white rounded-none md:rounded-lg z-50  lg:mt-[20px]  mt-[0px]'>
        <div className=' relative w-full'>
          <div class="flex lg:flex-none h-screen lg:h-fit  flex-col lg:flex-row w-full flex-nowrap lg:flex-wrap">

            <div className='hidden md:flex lg:flex-none w-full h-[20px] mt-[20px]'>
              <div className='flex-none ml-auto mr-[1.5rem]'>
                <img data-testid='popup-close-button' onClick={ (e)=> { setIsShowHelpModal(false) }} src={iconModalClose} alt="ic-close-modal" className=' cursor-pointer w-[16px] h-[16px]' /> 
              </div>
            </div>
            <div className='flex md:hidden lg:flex-none w-full h-[20px] mt-[20px]'>
              <div className='flex-none ml-auto mr-[1.5rem]'>
                <img data-testid='popup-close-button' onClick={ (e)=> { setIsShowHelpModal(false) }} src={iconModalClose} alt="ic-close-modal" className=' cursor-pointer w-[24px] h-[24px]' /> 
              </div>
            </div>
          
            <div className='flex md:hidden flex-wrap w-full justify-center border-b-[0.5px] border-grey-500 mt-[15px] mb-[20px] '>
            </div>

            <div className='flex lg:flex-none flex-wrap w-full h-[72px] px-6 '>
              <div className='flex flex-wrap w-full justify-center'>
                <span className='md:flex text-xl md:text-[24px] font-medium leading-8 md:leading-[44px] text-center'>หากคุณต้องการให้เราติดต่อกลับ</span>
              </div>
              <div className='flex flex-wrap w-full justify-center mt-[0px] mb-[16px]'>
                <span className='hidden md:flex text-base md:text-[18px] leading-6 text-grey-600 text-center'>กรอกรายละเอียดปัญหาที่คุณพบเจอเกี่ยวกับ<br/>การเรียกร้องค่าสินไหมทดแทน</span>
                <span className='flex md:hidden  text-base md:text-[18px] leading-6 text-grey-600 text-center'>กรอกรายละเอียดปัญหาที่คุณพบเจอ<br/>เกี่ยวกับการเรียกร้องค่าสินไหมทดแทน</span>
              </div>


              <div className=' flex-wrap w-full '>
                <div className='flex flex-wrap w-full'>
                  <div className=' flex-wrap w-full'>
                    <span className='text-sm font-medium leading-5 text-black'>ชื่อผู้ติดต่อ<span className='text-red-500'>*</span></span>
                  </div>
                  <div className=' flex-wrap w-full'>
                    <input data-testid='dropLead-name-input' value={customerName} onChange={ (e)=> { onChangeText( e, setCustomerName )  }} type={'search'} className={'w-full h-[48px] mt-1  font-prompt text-md border py-2 px-4 rounded-lg focus:outline-none focus:border-green-500 focus:border-1 focus:box-border focus:shadow-normal focus:shadow-green-400 ' + ( (false)? ' border-red-500 ' : ' border-grey-300 ' )} placeholder='ชื่อ - นามสกุล' />
                  </div>  
                </div>
                <div className='flex flex-wrap w-full mt-6'>
                  <div className=' flex-wrap w-full'>
                    <span className='text-sm font-medium leading-5 text-black'>อีเมล </span><span className='text-grey-500 font-normal'>(ถ้ามี)</span>
                  </div>
                  <div className=' flex-wrap w-full'>
                    <input data-testid='dropLead-email-input' value={customerEmail} onChange={ (e)=> { onChangeEmail( e, setCustomerEmail )  }} type={'search'} className={'w-full h-[48px] mt-1  font-prompt text-md border py-2 px-4 rounded-lg focus:outline-none focus:border-green-500 focus:border-1 focus:box-border focus:shadow-normal focus:shadow-green-400 ' + ( (false)? ' border-red-500 ' : ' border-grey-300 ' )} placeholder='your@company.com' />
                  </div>  
                </div>
                <div className='flex flex-wrap w-full mt-6'>
                  <div className=' flex-wrap w-full'>
                    <span className='text-sm font-medium leading-5 text-black'>เบอร์โทรศัพท์<span className='text-red-500'>*</span></span>
                  </div>
                  <div className=' flex-wrap w-full'>
                    <input data-testid='dropLead-contactNo-input' value={customerTel} onChange={ (e)=> { 
                      onChangeNumber( e, setCustomerTel )  
                      }} type={'search'} className={'w-full h-[48px] mt-1  font-prompt text-md border py-2 px-4 rounded-lg focus:outline-none focus:border-green-500 focus:border-1 focus:box-border focus:shadow-normal focus:shadow-green-400 ' + ( (false)? ' border-red-500 ' : ' border-grey-300 ' )}  placeholder='000 000 0000' />
                  </div>  
                </div>
                <div className='flex flex-wrap w-full mt-6'>
                  <div className=' flex-wrap w-full'>
                    <label for="customer-message" className='text-sm font-medium leading-5 text-black'>ข้อความ<span className='text-red-500'>*</span></label>
                  </div>

                  <textarea data-testid='dropLead-message-input' id="customer-message" rows={5} value={customerMessage} onChange={ (e)=> { onChangeText( e, setCustomerMessage )  }} type={'search'} className={'w-full h-[104px] mt-1  font-prompt text-md border py-2 px-4 rounded-lg focus:outline-none focus:border-green-500 focus:border-1 focus:box-border focus:shadow-normal focus:shadow-green-400 ' + ( (false)? ' border-red-500 ' : ' border-grey-300 ' )}  />

                </div>

                <button 
                    data-testid='dropLead-submit-button'
                    onClick={submit}
                    disabled={!isValid}
                    className={'w-full lg:px-4 text-base leading-6 h-[48px]  mt-6 md:h-12 font-medium rounded-lg border-radius-other  '+ ( (!isValid)? ' bg-grey-100 text-white  ' : ' bg-green-500 text-white ')}>
                      ส่งข้อความ
                </button>
              </div>
            </div>

          </div>


        </div>


      
      </div>

    </div>
    
    <div className="flex flex-wrap w-full bg-white font-prompt overflow-y-hidden  overflow-x-hidden ">

      <div className='fixed w-full z-30'>
        <div className='flex w-full flex-wrap'>
          <div className="flex flex-wrap w-full bg-green-500 py-2.5 md:py-4 px-4 justify-center">


            <div className="flex w-[1092px] ">

              <div className="flex-none">
                <div className='pr-4 border-r border-green-300'>
                  <div className='h-[34] md:h-[40px]' >
                    <ThaivivatLogo></ThaivivatLogo>
                  </div>


                </div>
              </div>

              <div className="grow flex-wrap w-full pl-4 my-[1px]">
                <span className='flex w-full text-[10px] md:text-xs font-medium leading-3 text-grey-700'>เลขรับแจ้ง</span>
                <span className='flex w-full mt-0 md:mt-1 text-sm md:text-base font-medium leading-5 text-white'>{ props.notify_no }</span>
              </div>

            </div>


          </div>

          <div className="flex  w-full bg-white border-b border-grey-800">
                
                <div className='flex-none  flex py-[18px] md:py-7 px-4 md:px-6'>
                  <img onClick={()=> { showCancelUpload() }} src={iconClose} alt="icon-close" className=' cursor-pointer w-[24px] h-[24px] my-auto' />
                </div>

                <div className='grow md:grow-0 flex w-full md:justify-center'>
                  <div className='overflow-x-auto overflow-hidden flex md:flex-wrap md:w-[1092px] '>

                    <div
                    data-testid='tab-claimantInfo-text' 
                    onClick={ (e)=> { onHandlerClickMenu(1) }} 
                    className={(( enableStep.step1)? ' cursor-pointer ' : '')+'  flex-none flex w-[220px] md:w-1/3 h-[80px] px-[20px] py-[20px] '+((step == 1)? ' border-b-[3px] border-green-500 ' : '')}>
                      <div className='flex-warp w-[168px] md:w-full my-auto'>
                        {
                          (lastStep >= 2)?
                            <span className=' w-full text-[12px] leading-4 font-medium text-green-500'>ข้อมูลครบถ้วน</span>
                          :
                          null
                        }
                        <p className=' w-full mt-1 text-sm md:text-[16px] md:leading-[20px] not-italic font-medium truncate'>1. ข้อมูลผู้เรียกร้อง, การติดต่อ</p>
                      </div>
                      <div className='flex-none ml-1 my-auto'>
                        {
                          (lastStep >= 2)?
                            <img src={iconChecked} alt="icon-checked" className='' /> :
                            null
                        }
                      </div>
                    </div>

                    <div
                    data-testid='tab-claimDetails-text' 
                    onClick={ (e)=> { onHandlerClickMenu(2) }}  
                    className={(( enableStep.step2)? ' cursor-pointer ' : '')+'  flex-none flex w-[220px] md:w-1/3 h-[80px]  px-[20px] py-[20px]  '+((step == 2)? ' border-b-[3px] border-green-500 ' : '')}>
                      <div className='flex-warp w-[168px] md:w-full my-auto'>
                        {
                          (lastStep === 3)?
                            <span className=' w-full text-[12px] leading-4 font-medium text-green-500'>ข้อมูลครบถ้วน</span>
                          :
                          null
                        }
                        <p className={' w-full mt-1 text-sm md:text-base md:leading-5 font-medium  not-italic truncate text-grey-800 '+( (step == 3)? ' text-black   ' : ' text-grey-800 ' )}>2. รายละเอียดการเรียกร้องค่าสินไหม</p>
                      </div>
                      <div className='flex-none  ml-1 my-auto'>
                        {
                          (lastStep === 3)?
                            <img src={iconChecked} alt="icon-checked" className='' /> :
                            null
                        }
                      </div>
                    </div>

                    <div
                    data-testid='tab-confirmDetails-text' 
                    onClick={ (e)=> { onHandlerClickMenu(3) }}   
                    className={(( enableStep.step3)? ' cursor-pointer ' : '')+'  flex-none flex w-[220px] md:w-1/3 h-[80px]  px-[20px] py-[20px]  '+((step === 3)? ' border-b-[3px] border-green-500 ' : '')}>
                      <div className='flex-warp w-[168px] md:w-full my-auto'>
                        <p className={'my w-full mt-1 text-sm md:text-base md:leading-5 font-medium not-italic truncate text-grey-800 '+( (step === 3)? ' text-black   ' : ' text-grey-800 ' )}>3. ยืนยันข้อมูล</p>
                      </div>
                    </div>

                    <div className='flex-none flex md:hidden w-[180px] px-5  '>
                    </div>

                  </div>
                </div>

          
          </div>
          
          <div onClick={(e) => { setIsShowHelpModal(true) }} className={"fixed !block right-10 w-[136px] h-[48px]  bg-white border  rounded-full  px-[20px] py-[12px] shadow-md cursor-pointer  " } style={{bottom:isShowHelpButton}}  >
            <div className="flex" >   
              <img src={imgQuestion} alt="banner-claim-paper" className='w-[20px] h-[20px] mr-[8px]' />
              <span>ช่วยเหลือ</span>
            </div>
          </div>


        </div>
      </div>

  
      <div className='flex w-full overflow-y-auto mt-[110px] md:mt-[152px] py-6'>

        {
          (step === 1)?
            <Step1 
            onSuccess={onSuccessStep1} 
            onSearchRefNo={onSearchRefNo} />
          :
          (step === 2)?
            <Step2 onSelectedFile={onSelectedFile} onSuccess={onSuccessStep2}  />
            :
            <Step3 onConfirm={onConfirm} onEditStep1={onEditStep1}  onEditStep2={onEditStep2}   />
        }
        
        
    
      </div>

    </div>

      {
        isShowLoading ?
          <ProgressWaiting />
        :
        null
      }


      {
          isShowAlertError ?

          <ModalAlertError 
            title={alertTitle}
            message={alertMessage}
            confirmClick={confirmClickError}
          />
          :
          null
      }

      <div className={((isShowAlertEmail)? ' fixed ' : ' hidden ' )+ 'bg-[#252525]  text-white  top-[9%]  flex inset-x-0 mx-auto shadow-alert  w-fit h-[40px] py-[10px] px-[12px] mb-[40px] rounded-lg z-50'}>
        <img src={iconWarningAlert} alt="icon-warning-alert" className='w-[16px] h-[16px] mr-[8px] my-auto' />
        <span className='text-sm not-italic font-normal  my-auto' >{alertText}</span>
        <button onClick={(e) => { setIsShowAlertEmail(false) }}><img src={iconCloseAlert} alt="icon-close-alert " className='w-[16px] h-[16px] ml-[8px] my-auto' /></button>
      </div>
  </div>
  )
}

const mapStateToProps = state => {
  return state
}
const mapDispatchToProps = dispatch => {
  return {
    updateContactInfo : (payload) =>  dispatch(updateContactInfo(payload)),
    updateContactInfoTemporary : (payload) =>  dispatch(updateContactInfoTemporary(payload)),
    updateClaimType : (payload) =>  dispatch(updateClaimType(payload)),
    deleteDocTypeAll : () =>   dispatch(deleteDocTypeAll()),
    updateClaimId : (payload) =>   dispatch(updateClaimId(payload)),

    updateDocsType1 : (payload) =>  dispatch(updateDocsType1( payload )),
    updateDocsType2 : (payload) =>  dispatch(updateDocsType2( payload )),
    updateDocsType3 : (payload) =>  dispatch(updateDocsType3( payload )),
    updateDocsType4 : (payload) =>  dispatch(updateDocsType4( payload )),
    updateDocsType5 : (payload) =>  dispatch(updateDocsType5( payload )),
    updateDocsType6 : (payload) =>  dispatch(updateDocsType6( payload )),
    updateDocsType7 : (payload) =>  dispatch(updateDocsType7( payload )),
    updateDocsType8 : (payload) =>  dispatch(updateDocsType8( payload )),
    updateDocsType9 : (payload) =>  dispatch(updateDocsType9( payload )),
    updateDocsType10 : (payload) =>  dispatch(updateDocsType10( payload )),
    updateDocsType11 : (payload) =>  dispatch(updateDocsType11( payload )),
    updateDocsType12 : (payload) =>  dispatch(updateDocsType12( payload )),
    updateDocsType13 : (payload) =>  dispatch(updateDocsType13( payload )),
    updateDocsType14 : (payload) =>  dispatch(updateDocsType14( payload )),
    updateDocsType15 : (payload) =>  dispatch(updateDocsType15( payload )),
    updateDocsType16 : (payload) =>  dispatch(updateDocsType16( payload )),
    updateDocsType17 : (payload) =>  dispatch(updateDocsType17( payload )),
    updateDocsType18 : (payload) =>  dispatch(updateDocsType18( payload )),
    updateDocsType19 : (payload) =>  dispatch(updateDocsType19( payload )),
    updateDocsType20 : (payload) =>  dispatch(updateDocsType20( payload )),
    updateDocsType21 : (payload) =>  dispatch(updateDocsType21( payload )),

    deleteDocType1 : (payload) =>  dispatch(deleteDocType1( payload )),
    deleteDocType2 : (payload) =>  dispatch(deleteDocType2( payload )),
    deleteDocType3 : (payload) =>  dispatch(deleteDocType3( payload )),
    deleteDocType4 : (payload) =>  dispatch(deleteDocType4( payload )),
    deleteDocType5 : (payload) =>  dispatch(deleteDocType5( payload )),
    deleteDocType6 : (payload) =>  dispatch(deleteDocType6( payload )),
    deleteDocType7 : (payload) =>  dispatch(deleteDocType7( payload )),
    deleteDocType8 : (payload) =>  dispatch(deleteDocType8( payload )),
    deleteDocType9 : (payload) =>  dispatch(deleteDocType9( payload )),
    deleteDocType10 : (payload) =>  dispatch(deleteDocType10( payload )),
    deleteDocType11 : (payload) =>  dispatch(deleteDocType11( payload )),
    deleteDocType12 : (payload) =>  dispatch(deleteDocType12( payload )),
    deleteDocType13 : (payload) =>  dispatch(deleteDocType13( payload )),
    deleteDocType14 : (payload) =>  dispatch(deleteDocType14( payload )),
    deleteDocType15 : (payload) =>  dispatch(deleteDocType15( payload )),
    deleteDocType16 : (payload) =>  dispatch(deleteDocType16( payload )),
    deleteDocType17 : (payload) =>  dispatch(deleteDocType17( payload )),
    deleteDocType18 : (payload) =>  dispatch(deleteDocType18( payload )),
    deleteDocType19 : (payload) =>  dispatch(deleteDocType19( payload )),
    deleteDocType20 : (payload) =>  dispatch(deleteDocType20( payload )),
    deleteDocType21 : (payload) =>  dispatch(deleteDocType21( payload )),

    deleteAllDocType1 : () =>  dispatch(deleteDocType1All(  )),
    deleteAllDocType2 : () =>  dispatch(deleteDocType2All(  )),
    deleteAllDocType3 : () =>  dispatch(deleteDocType3All(  )),
    deleteAllDocType4 : () =>  dispatch(deleteDocType4All(  )),
    deleteAllDocType5 : () =>  dispatch(deleteDocType5All(  )),
    deletAlleDocType6 : () =>  dispatch(deleteDocType6All(  )),
    deleteAllDocType7 : () =>  dispatch(deleteDocType7All(  )),
    deleteAllDocType8 : () =>  dispatch(deleteDocType8All(  )),
    deleteAllDocType9 : () =>  dispatch(deleteDocType9All(  )),
    deleteAllDocType10 : () =>  dispatch(deleteDocType10All(  )),
    deleteAllDocType11 : () =>  dispatch(deleteDocType11All(  )),
    deleteAllDocType12 : () =>  dispatch(deleteDocType12All(  )),
    deleteAllDocType13 : () =>  dispatch(deleteDocType13All(  )),
    deleteAllDocType14 : () =>  dispatch(deleteDocType14All(  )),
    deleteAllDocType15 : () =>  dispatch(deleteDocType15All(  )),
    deleteAllDocType16 : () =>  dispatch(deleteDocType16All(  )),
    deleteAllDocType17 : () =>  dispatch(deleteDocType17All(  )),
    deleteAllDocType18 : () =>  dispatch(deleteDocType18All(  )),
    deleteAllDocType19 : () =>  dispatch(deleteDocType19All(  )),
    deleteAllDocType20 : () =>  dispatch(deleteDocType20All(  )),
    deleteAllDocType21 : () =>  dispatch(deleteDocType21All(  )),
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(NewInformPage);